import { IOrderGetFilters, OrderService } from '@/app/services/orders'
import {
  ErrorResponse,
  IPaginationParams,
  PaginatedQueryResponse,
} from '@/types/api'
import { IOrder } from '@/types/order'
import { useQuery, UseQueryOptions } from 'react-query'

export function useOrders(
  filters: IOrderGetFilters = {},
  pagination: IPaginationParams = {},
  options?: Omit<
    UseQueryOptions<PaginatedQueryResponse<IOrder>, ErrorResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery<PaginatedQueryResponse<IOrder>, ErrorResponse>(
    [OrderService.GET_PATH, filters, pagination],
    () => OrderService.getOrders(filters, pagination),
    options
  )
}
